import { create } from "zustand";

import type { AuditTabId } from "../features/actions/mockData";

export type OpenActionPanel = "analyst-notes" | "internal-audit" | "actions" | undefined;

interface ActionPanelState {
  openPanel: OpenActionPanel;
  auditTabId: AuditTabId | undefined;
  setOpenPanel: (panel: OpenActionPanel) => void;
  openInternalAudit: (tabId: AuditTabId) => void;
}

/**
 * Cross-feature panel coordination: `review`'s DealStatus section needs to
 * open the Internal/Audit drawer owned by `actions`' FAB cluster to a
 * specific tab, so the single-open-panel state can't stay local to
 * ActionFabCluster. `setOpenPanel` clears `auditTabId` so a plain FAB click
 * always lands on the drawer's first tab; only `openInternalAudit` targets one.
 */
export const useActionPanelStore = create<ActionPanelState>((set) => ({
  openPanel: undefined,
  auditTabId: undefined,
  setOpenPanel: (panel) => set({ openPanel: panel, auditTabId: undefined }),
  openInternalAudit: (tabId) => set({ openPanel: "internal-audit", auditTabId: tabId }),
}));

/** Test-only: clears state so it doesn't leak between tests in the same file. */
export function resetActionPanelStore() {
  useActionPanelStore.setState({ openPanel: undefined, auditTabId: undefined });
}
